import { render, staticRenderFns } from "./productsgetstatus.vue?vue&type=template&id=63eb7263&"
import script from "./productsgetstatus.vue?vue&type=script&lang=js&"
export * from "./productsgetstatus.vue?vue&type=script&lang=js&"
import style0 from "./productsgetstatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports